import styled from "styled-components";
import { Spacing } from "components/designV2/constants";
import { Text } from "components/designV2/text/text";

export const ShiftFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
`;

export const ShiftDateWrap = styled.div`
  .date-picker-container {
    max-width: 100%;
    width: 100%;
  }
`;

export const ShiftFieldsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ShiftField = styled.div`
  width: 150px;
`;

export const ShiftActionRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ShiftActionButtonsRow = styled.div`
  display: flex;
  gap: 12px;
`;

export const BreakFieldsRow = styled(ShiftFieldsRow)`
  margin-bottom: 30px;
`;

export const ToggleTimeIntervalText = styled(Text)`
  cursor: pointer;
`;
